import styled from "styled-components";
import { useDeviceType } from "../../../contexts/DeviceContext"
import { HeroBanner,Row,Col } from "../../../style/base.style"
import { bannerBackground, hexagenBg } from "../../../constants/images";



interface HeroProps {
    children?: React.ReactNode;
    backgroundImage?: string;
    backgroundColor?: string;
    heroImg?: string;
    height?: number;
}

export const Hero = ({heroImg,backgroundImage,children,backgroundColor,height}:HeroProps) => {
    const {isMobile} = useDeviceType()
    return (
        <HeroBanner $height={height || 60} $backgroundImage={hexagenBg} $background={backgroundColor} $backgroundSize="contain"   className="hero-banner" $padding={`${isMobile?0:0}px 0 0 0`}  $alignItems={isMobile?"center":"center"}>
          {
            isMobile &&
            <Col $position="absolute"  $zIndex={-1}  $height="100%"  className="test1" >
              <VImage src={heroImg} $opacity={0.15}  alt="doctor" />
          </Col>
          }

        <Row  $height="100%" className="rowww" $alignItems="ceenter">
          <Col $width={isMobile?'100%':'40%'} $alignItems="flex-start" $height="100%">
            {children}
          </Col>
          {
            !isMobile &&
            <Col $width="30%" $justifyContent="flex-end" $height="100%">
            <VImage src={heroImg}  alt="doctor"/>
          </Col>
          }
       


          
        </Row>

        </HeroBanner>
    )
}


const VImage = styled.img<{$width?:string,$height?:string,$blur?:number,$opacity?:number,$borderRadius?:string}>`
    width: ${props => props.$width || '100%'};
    height: ${props => props.$height || 'auto'};
    opacity: ${props => props.$opacity || 1};
    border-radius: ${props => props.$borderRadius || '0'};
    object-fit: contain;
    display: block;
    @media (max-width: 767.98px) {
            justify-items: center;
            height: 100%;
            

    }
`;